var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Money } from "./../../Primitives/Money";
export class ServiceDescriptor {
  constructor(_data) {
    /**
     */
    __publicField(this, "Code");
    /**
     */
    __publicField(this, "Country");
    /**
     */
    __publicField(this, "IsCountryBased");
    /**
     */
    __publicField(this, "Price");
    /**
     */
    __publicField(this, "PricingType");
    /**
     */
    __publicField(this, "Type");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ServiceDescriptor
     */
    __publicField(this, "$type", "V1.Services.V2.ServiceDescriptor");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Code = ServiceDescriptorCode[_data["Code"]];
      this.Country = _data["Country"];
      this.IsCountryBased = _data["IsCountryBased"];
      if (_data["Price"]) {
        const price_ = new Money();
        this.Price = price_.init(_data["Price"]);
      }
      this.PricingType = ServiceDescriptorPricingType[_data["PricingType"]];
      this.Type = ServiceDescriptorType[_data["Type"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Code"] = ServiceDescriptorCode[this.Code];
    _data["Country"] = this.Country;
    _data["IsCountryBased"] = this.IsCountryBased;
    _data["Price"] = this.Price ? this.Price.toJSON() : void 0;
    _data["PricingType"] = ServiceDescriptorPricingType[this.PricingType];
    _data["Type"] = ServiceDescriptorType[this.Type];
    return _data;
  }
}
export var ServiceDescriptorCode = /* @__PURE__ */ ((ServiceDescriptorCode2) => {
  ServiceDescriptorCode2["VatCompliance"] = "VatCompliance";
  ServiceDescriptorCode2["VatMonthlyCompliance"] = "VatMonthlyCompliance";
  ServiceDescriptorCode2["VatRegistration"] = "VatRegistration";
  ServiceDescriptorCode2["VatTakeOver"] = "VatTakeOver";
  ServiceDescriptorCode2["VatFiscalRepresentative"] = "VatFiscalRepresentative";
  ServiceDescriptorCode2["OptionalFiscalRepresentative"] = "OptionalFiscalRepresentative";
  ServiceDescriptorCode2["VatFilingAgent"] = "VatFilingAgent";
  ServiceDescriptorCode2["VatRetrospectiveReturn"] = "VatRetrospectiveReturn";
  ServiceDescriptorCode2["VatIntrastatIn"] = "VatIntrastatIn";
  ServiceDescriptorCode2["VatIntrastatOut"] = "VatIntrastatOut";
  ServiceDescriptorCode2["VatDeregistration"] = "VatDeregistration";
  ServiceDescriptorCode2["VatSelfRevision"] = "VatSelfRevision";
  ServiceDescriptorCode2["VatHomeCountryCompliance"] = "VatHomeCountryCompliance";
  ServiceDescriptorCode2["IossComplianceTier0"] = "IossComplianceTier0";
  ServiceDescriptorCode2["IossComplianceTier1"] = "IossComplianceTier1";
  ServiceDescriptorCode2["IossComplianceTier2"] = "IossComplianceTier2";
  ServiceDescriptorCode2["IossComplianceTier3"] = "IossComplianceTier3";
  ServiceDescriptorCode2["IossRegistration"] = "IossRegistration";
  ServiceDescriptorCode2["IossTakeOver"] = "IossTakeOver";
  ServiceDescriptorCode2["IossDeregistration"] = "IossDeregistration";
  ServiceDescriptorCode2["OssCompliance"] = "OssCompliance";
  ServiceDescriptorCode2["OssRegistration"] = "OssRegistration";
  ServiceDescriptorCode2["OssTakeOver"] = "OssTakeOver";
  ServiceDescriptorCode2["OssDeregistration"] = "OssDeregistration";
  ServiceDescriptorCode2["OssQuarterlyCompliance"] = "OssQuarterlyCompliance";
  ServiceDescriptorCode2["GlobalEoriUk"] = "GlobalEoriUk";
  ServiceDescriptorCode2["GlobalEoriEu"] = "GlobalEoriEu";
  ServiceDescriptorCode2["GlobalGeneralVatAdvice"] = "GlobalGeneralVatAdvice";
  ServiceDescriptorCode2["GlobalSpecialistVatAdvice"] = "GlobalSpecialistVatAdvice";
  ServiceDescriptorCode2["GlobalCommunicatingWithTaxAuthorities"] = "GlobalCommunicatingWithTaxAuthorities";
  ServiceDescriptorCode2["GlobalChangeCompanyDetail"] = "GlobalChangeCompanyDetail";
  ServiceDescriptorCode2["GlobalContactingTaxAuthorities"] = "GlobalContactingTaxAuthorities";
  ServiceDescriptorCode2["GlobalTranslation"] = "GlobalTranslation";
  ServiceDescriptorCode2["GlobalTaxCertificate"] = "GlobalTaxCertificate";
  ServiceDescriptorCode2["GlobalIntrastatThresholdCheck"] = "GlobalIntrastatThresholdCheck";
  ServiceDescriptorCode2["GlobalDistanceSaleThresholdCheck"] = "GlobalDistanceSaleThresholdCheck";
  return ServiceDescriptorCode2;
})(ServiceDescriptorCode || {});
export var ServiceDescriptorPricingType = /* @__PURE__ */ ((ServiceDescriptorPricingType2) => {
  ServiceDescriptorPricingType2["Hourly"] = "Hourly";
  ServiceDescriptorPricingType2["Monthly"] = "Monthly";
  ServiceDescriptorPricingType2["Yearly"] = "Yearly";
  ServiceDescriptorPricingType2["Fixed"] = "Fixed";
  ServiceDescriptorPricingType2["Custom"] = "Custom";
  ServiceDescriptorPricingType2["Quarterly"] = "Quarterly";
  return ServiceDescriptorPricingType2;
})(ServiceDescriptorPricingType || {});
export var ServiceDescriptorType = /* @__PURE__ */ ((ServiceDescriptorType2) => {
  ServiceDescriptorType2["OneTime"] = "OneTime";
  ServiceDescriptorType2["Subscription"] = "Subscription";
  ServiceDescriptorType2["OneTimeSubscription"] = "OneTimeSubscription";
  return ServiceDescriptorType2;
})(ServiceDescriptorType || {});
